<template>
    <f-dialog
        v-model      = "edit"
        :width       = "dialogWidth < 800 ? dialogWidth : 800"
        :show-header = "true"
        title        = "Anlagen"
        :show-delete = "false"
        :hide-actions = "true"
        @cancel      = "onCancel"
    >
        <template v-slot:content>
            <div class="v-flex mb-4 mt-2">
                <v-spacer />
                <v-btn
                    class  = "dialog-button ml-3"
                    color  = "primary"
                    @click = "onErrors"
                    style  = "width: 185px;"
                >
                    {{ filter.errors ? $t("importer.filter.unit.errors.on") : $t("importer.filter.unit.errors.off") }}
                </v-btn>
            </div>

            <p-import-content
                id             = "import-units-id"
                :rows          = "units"
                :columns       = "columns"
                :size          = "{ x: dialogWidth < 800 ? dialogWidth : 800+75, y: 600 }"
                :show-units    = "false"
                :filter        = "filter"
                :scroll-width  = "dialogWidth"
                :right-padding ="0"
                :target-format = "true"
            />
        </template>
    </f-dialog>
</template>

<script>
import FDialog        from "@/modules/core/components/utils/FDialog.vue";
import ImporterMixin  from "@/modules/msd/importer/mixins/ImporterMixin";
import PImportContent from "@/modules/msd/importer/components/private/PImportContent.vue";

export default {
    name: "PImportUnits",
    components: {
        PImportContent,
        FDialog
    },

    props: {
        value: {

        },

        columns: {

        },

        units: {

        },
    },

    mixins: [
        ImporterMixin
    ],

    data: () => ({
        dialogWidth: 500,
        edit: false,
        filter: {
            errors: false,
        }
    }),

    mounted() {
        this.edit = this.value;
    },

    watch: {
        value () {
            this.edit = this.value;
            if (this.edit) {
                this.initialize();
            }
        }
    },

    methods: {
        initialize () {
            let width = 0;
            this.columns.forEach(column => {
                width += column.width;
            });

            this.dialogWidth = width;
        },

        onErrors () {
            this.filter.errors = !this.filter.errors;
        },

        onCancel() {
            this.$emit("input", false);
        },
    }
}
</script>

<style scoped>

</style>